module.exports = __webpack_public_path__ + "assets/img/LTC003.3b62ec84.png";